import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const epilepsy: AnswerPathTreeNode = {
  path: 'epilepsy',
  children: [
    { path: 'hasCondition', nodeId: NodeIds.healthInsuredEpilepsyHasCondition },
    { path: 'details', nodeId: NodeIds.healthInsuredEpilepsyDetails },
  ],
};
